import { ticket_stateConstants } from "../_constants";

const initialState = {
    loading: false,
    item: {},
    items: [],
    error: "",
};

export const ticket_state = (state = initialState, action) => {
    switch (action.type) {
        case ticket_stateConstants.GETALL_TICKET_STATE_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case ticket_stateConstants.GETALL_TICKET_STATE_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.ticket_state,
            };

        case ticket_stateConstants.GETALL_TICKET_STATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case ticket_stateConstants.ADD_TICKET_STATE_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case ticket_stateConstants.ADD_TICKET_STATE_SUCCESS:
            return {
                ...state,
                loading: false,
                items: [...state.items, action.ticket_state],
            };

        case ticket_stateConstants.ADD_TICKET_STATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case ticket_stateConstants.UPDATE_TICKET_STATE_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case ticket_stateConstants.UPDATE_TICKET_STATE_SUCCESS:
            return {
                ...state,
                loading: false,
                items: [
                    ...state.items.map((p) => {
                        if (
                            parseInt(p.id_state) ===
                            parseInt(action.ticket_state.id_state)
                        ) {
                            Object.assign(p, action.ticket_state);
                        }
                        return p;
                    }),
                ],
            };

        case ticket_stateConstants.UPDATE_TICKET_STATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case ticket_stateConstants.DELETE_TICKET_STATE_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case ticket_stateConstants.DELETE_TICKET_STATE_SUCCESS:
            return {
                ...state,
                loading: false,
                items: [
                    ...state.items.filter(
                        (p) =>
                            parseInt(p.id_state) !==
                            parseInt(action.ticket_state)
                    ),
                ],
            };

        case ticket_stateConstants.DELETE_TICKET_STATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        default:
            return state;
    }
};
